import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveUnidadeGerencia } from '@services/UnidadeGerencia/Index.jsx';
import { useForm } from 'react-hook-form';
import SelectOptionComp from "@components/UI/SelectOption/Index.jsx";
import { useEffect, useState } from "react";
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import { goOptions, porteOptions, typesRegistrationOptions } from "@enums/UnidadeGerencia/Index.jsx";
import { selectMessage } from '@utils/Index.jsx';
import { useFetchDataGerentes } from "@hooks/api/Usuario/useFetchDataGerentes";
import { useFetchDataEncarregados } from "@hooks/api/Usuario/useFecthDataEncarregados";
import ValidationsUnidadeGerencia from "@validations/UnidadeGerencia/Validations.jsx";
import { getFieldPropertiesCreate } from "@utils/UnidadeGerencia/Index";

const Create = ({ onSave }) => {
  // State deve ser null ou a option, não string vazia
  const [selectedOptionTypeRegistration, setSelectedOptionTypeRegistration] = useState(null);
  const [selectedOptionGO, setSelectedOptionGO] = useState(null);
  const [selectedOptionPorte, setSelectedOptionPorte] = useState(null);

  const { gerentesOptions, gerenteLoading, fetchGerentes } = useFetchDataGerentes();
  const { encarregadosOptions, encarregadoLoading, fetchEncarregados } = useFetchDataEncarregados();

  useEffect(() => {
    fetchGerentes();
    fetchEncarregados();
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues: {
      tipoCadastro: null,
      nome: '',
      sigla: '',
      gerente: null,
      encarregado: null,
      numero: '',
      go: null,
      porte: null,
    }
  });

  const onSubmit = async (data) => {
    try {
      // Troque .label por .value e compare sempre com string!
      const tipoCadastroValue = selectedOptionTypeRegistration?.value;

      const { validateFields } = ValidationsUnidadeGerencia();

      const errors = validateFields({
        ...data,
        selectedOptionTypeRegistration,
        selectedOptionGO,
        selectedOptionPorte,
      });

      if (Object.keys(errors).length > 0) {
        const errorMessage = Object.values(errors).join("\n");
        SweetAlert.error("Erro na Validação", errorMessage);
        return;
      }

      if (data.sigla) {
        const title = `Sigla da ${selectedOptionTypeRegistration?.label}`;
        const message = `Deseja realmente salvar a sigla desta ${tipoCadastroValue} como <strong>${data.sigla}</strong> ? Depois não será possível alterar.`;
        const confirmSigla = await SweetAlert.warningHTML(title, message);
        if (!confirmSigla) {
          return;
        }
      }

      SweetAlert.loading();

      const payload = {
        tipoCadastro: tipoCadastroValue,
        nome: data.nome.toUpperCase(),
        sigla: data.sigla.toUpperCase(),
        idGerente: data.gerente?.value,
        idEncarregado: data.encarregado?.value,
        numero: data.numero,
        go: selectedOptionGO ? selectedOptionGO.value : null,
        porte: selectedOptionPorte ? selectedOptionPorte.value : null,
      };

      const result = await SaveUnidadeGerencia(payload);

      SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');
      onSave({ ...result });

      setSelectedOptionTypeRegistration(null);
      setSelectedOptionGO(null);
      setSelectedOptionPorte(null);
      reset();
    } catch (error) {
      const errorMessage = error.parsed?.message || 'Não foi possível salvar a unidade/gerência.';

      SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
      console.error(error);
    }
  };

  const handleSelectChangeTypeRegistration = (option) => {
    setSelectedOptionTypeRegistration(option ? option : null);
    setSelectedOptionGO(null);
    setSelectedOptionPorte(null);
    reset();
  };

  const handleSelectChangeGO = (option) => {
    setSelectedOptionGO(option ? option : null);
  };

  const handleSelectChangePorte = (option) => {
    setSelectedOptionPorte(option ? option : null);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form">
      <div className="row g-0">

        <div className="p-3">
          <h3> - Observação: É necessário selecionar o tipo de cadastro antes de o sistema habilitar os demais campos. </h3>
        </div>

        <div className="row col-12 col-md-6">

          <SelectOptionComp
            label={"Tipo de Cadastro"}
            options={typesRegistrationOptions}
            value={selectedOptionTypeRegistration}
            onChange={handleSelectChangeTypeRegistration}
            placeholder={selectMessage}
            hoverMessage={"Selecionar um Tipo de Cadastro"}
            isClearable={true}
            required
          />

          <InputTextComp
            label={getFieldPropertiesCreate('nome', selectedOptionTypeRegistration).label}
            name={"nome"}
            {...register('nome')}
            placeholder={getFieldPropertiesCreate('nome', selectedOptionTypeRegistration).placeholder}
            hoverMessage={"Unidade/Gerência/Campus/Hotéis/EDS(Editora)"}
            maxLength={255}
            disabled={getFieldPropertiesCreate('nome', selectedOptionTypeRegistration).isDisabled}
            required={true}
          />

          <InputTextComp
            label={getFieldPropertiesCreate('sigla', selectedOptionTypeRegistration).label}
            name={"sigla"}
            {...register('sigla')}
            placeholder={getFieldPropertiesCreate('sigla', selectedOptionTypeRegistration).placeholder}
            hoverMessage={"Preencher a Sigla de uma Unidade/Gerência"}
            maxLength={255}
            disabled={getFieldPropertiesCreate('sigla', selectedOptionTypeRegistration).isDisabled}
            required={true}
            onInput={(e) => {
              e.target.value = e.target.value
                .replace(/[^a-zA-Z]/g, '')  // Remove tudo que não for letra
                .toUpperCase()              // Transforma em letra maiúscula
                .slice(0, 3);               // Limita a 3 letras
            }}
          />

          <InputTextComp
            label={getFieldPropertiesCreate('numero', selectedOptionTypeRegistration).label}
            name={"numero"}
            type={"number"}
            {...register('numero')}
            placeholder={getFieldPropertiesCreate('numero', selectedOptionTypeRegistration).placeholder}
            hoverMessage={"Preencher exclusivamente com caracteres númericos para Cadastro de Unidade ou Gerência."}
            disabled={getFieldPropertiesCreate('numero', selectedOptionTypeRegistration).isDisabled}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
              if (e.target.value.length > 2) {
                e.target.value = e.target.value.slice(0, 2); // Limita a 2 caracteres
              }
            }}
            required={true}
          />

        </div>

        <div className="col-6 col-md-6">

          <SelectOptionComp
            label={getFieldPropertiesCreate('gerente', selectedOptionTypeRegistration).label}
            options={gerentesOptions}
            isLoading={gerenteLoading}
            value={watch('gerente')}
            onChange={(sel) => setValue('gerente', sel)}
            placeholder={getFieldPropertiesCreate('gerente', selectedOptionTypeRegistration).placeholder}
            isDisabled={getFieldPropertiesCreate('gerente', selectedOptionTypeRegistration).isDisabled}
            isClearable
            required
          />

          <SelectOptionComp
            label={getFieldPropertiesCreate('encarregado', selectedOptionTypeRegistration).label}
            options={encarregadosOptions}
            isLoading={encarregadoLoading}
            value={watch('encarregado')}
            onChange={(sel) => setValue('encarregado', sel)}
            placeholder={getFieldPropertiesCreate('encarregado', selectedOptionTypeRegistration).placeholder}
            isDisabled={getFieldPropertiesCreate('encarregado', selectedOptionTypeRegistration).isDisabled}
            isClearable
            required
          />

          <SelectOptionComp
            label={"GO (Unidade)"}
            name={"go"}
            options={goOptions}
            value={selectedOptionGO}
            onChange={handleSelectChangeGO}
            isClearable={true}
            placeholder={getFieldPropertiesCreate('go', selectedOptionTypeRegistration).placeholder}
            hoverMessage={"Preenchimento Exclusivo para Cadastro de Unidades"}
            isDisabled={getFieldPropertiesCreate('go', selectedOptionTypeRegistration).isDisabled}
            required
          />

          <SelectOptionComp
            label={"Porte (Unidade)"}
            name={"porte"}
            options={porteOptions}
            value={selectedOptionPorte}
            onChange={handleSelectChangePorte}
            isClearable={true}
            placeholder={getFieldPropertiesCreate('porte', selectedOptionTypeRegistration).placeholder}
            hoverMessage={"Preenchimento Exclusivo para Cadastro de Unidades"}
            isDisabled={getFieldPropertiesCreate('porte', selectedOptionTypeRegistration).isDisabled}
            required
          />
        </div>

        <div className="col-md-12 mt-4">
          <ButtonComp
            title={"SALVAR"}
            type={"submit"}
            buttonColor={"#2b97be"}
            classnameIcon={"fa-regular fa-floppy-disk"}
            hoverMessage={"Botão para confirmar o cadastro"}
          />
        </div>

      </div>
    </form>
  );
};

export default Create;